import { __extends } from "tslib";
import { EventBase } from './EventBase';
var TransformEvent = /** @class */ (function (_super) {
    __extends(TransformEvent, _super);
    function TransformEvent(type, transform) {
        var _this = _super.call(this, type) || this;
        _this._transform = transform;
        return _this;
    }
    Object.defineProperty(TransformEvent.prototype, "transform", {
        /**
         *
         * @returns {Transform}
         */
        get: function () {
            return this._transform;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Clones the event.
     * @return An exact duplicate of the current object.
     */
    TransformEvent.prototype.clone = function () {
        return new TransformEvent(this.type, this._transform);
    };
    /**
     *
     */
    TransformEvent.INVALIDATE_MATRIX3D = 'invalidateMatrix3D';
    /**
     *
     */
    TransformEvent.INVALIDATE_COLOR_TRANSFORM = 'invalidateColorTransform';
    return TransformEvent;
}(EventBase));
export { TransformEvent };
